import { useEffect, useRef } from 'react';
import { Building2, Briefcase, Landmark } from 'lucide-react';

const audiences = [
  {
    icon: Building2,
    text: 'Founders heading toward an exit whose personal setup hasn\'t caught up with the company.',
  },
  {
    icon: Briefcase,
    text: 'Executives whose life and money cross more borders than their advisors do.',
  },
  {
    icon: Landmark,
    text: 'Family offices managing geographic risk across generations.',
  },
];

export default function WhoWeServe() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    const els = sectionRef.current?.querySelectorAll('.reveal');
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="who-we-serve"
      ref={sectionRef}
      data-testid="who-we-serve-section"
      className="relative py-24 md:py-32 bg-[#f7f6f3]"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="text-center mb-16 reveal">
          <p
            className="text-sm uppercase tracking-[0.3em] text-[#1a7a7a] mb-4 font-medium"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Clients
          </p>
          <h2
            className="text-4xl md:text-5xl font-semibold tracking-tight text-[#1a1a1a]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Who We Serve
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {audiences.map((item, idx) => {
            const Icon = item.icon;
            return (
              <div
                key={idx}
                data-testid={`audience-card-${idx}`}
                className={`reveal stagger-${idx + 1} group relative overflow-hidden rounded-2xl bg-white border border-gray-200 p-8 hover:border-[#1a7a7a]/40 hover:shadow-lg transition-all duration-500`}
              >
                <div className="w-12 h-12 rounded-xl bg-[#1a7a7a]/10 border border-[#1a7a7a]/15 flex items-center justify-center mb-6">
                  <Icon className="text-[#1a7a7a]" size={24} />
                </div>
                <p
                  className="text-gray-500 text-base leading-relaxed"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {item.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
